/* eslint-disable import/prefer-default-export */

/** Returns a circular index for a given relative index (can be negative) */
export const getCircularIndex = (index: number, length: number): number => ((index % length) + length) % length
